module.exports = __webpack_public_path__ + "build/img/up.a8a43690.png";